import { Injectable } from '@angular/core';
import { ModuleContainerServiceBase } from 'src/shared/services/module-container-service-base';

@Injectable({
    providedIn: 'root'
})
export class ModuleContainerService extends ModuleContainerServiceBase {
    constructor() {
        super(true);
    }
}
